<template>
  <div>
    <detail-title-con :extractInfo="extractInfo"></detail-title-con>
    <div class="list">
      <div class="list-title">
        <span>证据提取列表</span><button @click="goList">全部下载</button>
      </div>
      <div class="list-cont">
        <table
          class="table"
          v-if="$route.query.status != 7"
          style="
            white-space: normal;
            word-break: break-all;
            margin-top: 20px;
            width: 100%;
            table-layout: fixed;
          "
        >
          <thead style="width: 100%; border-right: 1px solid #d2d2d2">
            <tr style="background-color: #e4e4e4 !important; width: 100%">
              <td
                v-for="(item, index) in itemParas"
                :key="index"
                :style="{ width: item.width, 'text-align': 'center' }"
              >
                {{ item.name }}
              </td>
            </tr>
          </thead>
          <tbody
            v-if="!noDataEvidence"
            class="table-list"
            style="
              border-right: 1px solid #d2d2d2;
              border-bottom: 1px solid #d2d2d2;
              text-align: center;
            "
          >
            <tr
              v-for="(item, index) in extractList"
              :key="index"
              style="height: 30px"
            >
              <td
                style="
                  width: 150px;
                  height: 30px;
                  line-height: 15px;
                  padding: 5px;
                  text-align: center;
                "
              >
                {{ item.name }}
              </td>
              <td>{{ item.sourceTitle ? item.sourceTitle : "-" }}</td>
              <td>{{ item.productCodeName }}</td>
              <td>{{ item.statusName ? item.statusName : "-" }}</td>
              <td>{{ item.finishTimeFomate }}</td>
              <td>{{ item.fileSize ? item.fileSize : "-" }}</td>
              <td>{{ item.fileFormat ? item.fileFormat : "-" }}</td>
              <td class="data-actions" style="line-height: 10px">
                <span
                  class="icon-box icon-common-mark"
                  :title="item.remark"
                  style="
                    width: 22px;
                    height: 20px;
                    margin-right: 10px;
                    background-size: cover;
                  "
                ></span>
              </td>
              <td class="data-actions" style="line-height: 10px">
                <span
                  class="icon-box icon-common-floder"
                  v-if="
                    Number(item.hasChild) != 0 &&
                    item.status != 7 &&
                    item.status != 6 &&
                    item.isRefundFlag == 0 &&
                    $route.query.partnerId !=21 
                  "
                  @click="getDetail(index, 1)"
                  title="提取详情"
                  style="
                    width: 22px;
                    height: 20px;
                    margin-right: 20px;
                    background-size: cover;
                  "
                ></span>
                <!-- 存证 -->
                <span
                  class="icon-box icon-common-floder"
                  v-else-if="
                    Number(item.hasChild) != 0 &&
                    item.status == 7 &&
                    item.isRefundFlag == 0
                  "
                  @click="getDetail(index, 2)"
                  title="提取详情"
                  style="
                    width: 22px;
                    height: 20px;
                    margin-right: 20px;
                    background-size: cover;
                  "
                ></span>
                <span
                  class="icon-box icon-common-floder-disabled"
                  v-else
                  title="提取详情"
                  style="
                    width: 22px;
                    height: 20px;
                    margin-right: 20px;
                    background-size: cover;
                  "
                ></span>
                <!-- <span class="icon-common-floder icon-box" style="width:22px;height:20px;margin-right: 10px;background-size: cover;" title="证据详情"  v-if="Number(item.hasChild) != 0 && item.isRefundFlag == 0" @click="getDetail(index)" ></span> -->
                <!-- <template v-if="$route.query.extractingCode.substring(0, 2) == 'ZX'">
                    <span class="icon-box icon-common-eye" title="查看证书" v-if="isRefundFlag == 0" @click="showCer(index)" :style="{left: Number(item.hasChild) != 0 ? '68%' : '50%'}"></span>
                    <span class="icon-box icon-common-eye-disabled" title="查看证书" v-else  :style="{left: Number(item.hasChild) != 0 && item.isRefundFlag == 0? '68%' : '50%'}"></span>
                  </template>
                  <template v-else>
                    <span class="icon-box icon-common-eye" title="查看证书" @click="showCer(index)" :style="{left: Number(item.hasChild) != 0 ? '68%' : '50%'}"></span>
                  </template> -->
                <template v-if="item.status == 6 || item.status == 7">
                  <template v-if="item.status == 7">
                    <span
                      class="icon-box icon-common-eye-disabled"
                      v-if="item.isRefundFlag == 1 || (item.expirationTime<curTime && $route.query.partnerId == 21)"
                      title="查看证书"
                      :style="{
                        left: Number(item.hasChild) != 0 ? '68%' : '50%',
                      }"
                    ></span>

                    <span
                      class="icon-box icon-common-eye"
                      v-else
                      title="查看证书"
                      @click="showCer(index, 2, '', 0)"
                      :style="{
                        left: '68%',
                      }"
                    ></span>
                  </template>
                  <template v-else>
                    <span
                      class="icon-box icon-common-eye-disabled"
                      v-if="item.isRefundFlag == 1 || (item.expirationTime<curTime && $route.query.partnerId == 21)"
                      title="查看证书"
                      :style="{
                        left: Number(item.hasChild) != 0 ? '68%' : '50%',
                      }"
                    ></span>

                    <span
                      class="icon-box icon-common-eye"
                      v-else
                      title="查看证书"
                      @click="showCer(index, 2)"
                      :style="{
                        left: '68%',
                      }"
                    ></span>
                  </template>
                </template>
                <template v-else>
                  <span
                    class="icon-box icon-common-eye-disabled"
                    v-if="item.status == 5 || item.isRefundFlag == 1 || (item.expirationTime<curTime && $route.query.partnerId == 21)"
                    title="查看证书"
                    :style="{
                      left: Number(item.hasChild) != 0 ? '68%' : '50%',
                    }"
                  ></span>

                  <span
                    class="icon-box icon-common-eye"
                    v-else
                    title="查看证书"
                    @click="showCer(index)"
                    :style="{
                      left: '68%',
                    }"
                  ></span>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table"
          v-else
          style="
            white-space: normal;
            word-break: break-all;
            margin-top: 20px;
            width: 100%;
            table-layout: fixed;
          "
        >
          <thead style="width: 100%; border-right: 1px solid #d2d2d2">
            <tr style="background-color: #e4e4e4 !important; width: 100%">
              <td
                  v-for="item in evidenceSave.itemParas"
                  :style="{ width: item.width , 'text-align': 'center' }"
                >
                  {{ item.name }}
                </td>
            </tr>
          </thead>
          <tbody
            v-if="!noDataEvidence"
            class="table-list"
            style="
              border-right: 1px solid #d2d2d2;
              border-bottom: 1px solid #d2d2d2;
              text-align: center;
            "
          >
            <tr
              v-for="(item, index) in evidenceSaveList"
              :key="index"
              style="height: 30px"
            >
            <td v-text="item.certificateNumber" style="width: 12%"></td>
                <td  style="width: 11%;position: relative;">
                  <template v-if="item.evidenceName.length>20">
                  <el-tooltip class="item" effect="dark" :content="item.evidenceName" >
                    <span class="text_hidden" style="width:112px;">{{ item.evidenceName }}</span>
                  </el-tooltip>
                  <span class="copy_icon" :data-clipboard-text="item.evidenceName" title="点击复制" @click="EvidenceCopyFn(index,'.copy_icon','.copy_icon_msg1','copy_icon_msg_none1','copy_icon_msg_block1')"></span>
                  <span class="copy_icon_msg1 copy_icon_msg_none1" >复制成功</span>
                </template>
                <span v-else>{{ item.evidenceName }}</span>
                </td>
                <td
                  style="width: 10%;position: relative;"
                >
                <template v-if="item.owner.length>20">
                  <el-tooltip class="item" effect="dark" :content="item.owner" >
                    <span class="text_hidden" style="width:112px;">{{ item.owner }}</span>
                  </el-tooltip>
                  <span class="copy_icon" :data-clipboard-text="item.owner" title="点击复制" @click="EvidenceCopyFn(index,'.copy_icon','.copy_icon_msg2','copy_icon_msg_none2','copy_icon_msg_block2')"></span>
                  <span class="copy_icon_msg2 copy_icon_msg_none2" >复制成功</span>
                </template>
                <span v-else>{{ item.owner }}</span>
              </td>
                <td
                  v-text="item.typeName ? item.typeName : '-'"
                  style="width: 6%"
                ></td>
                <td
                  v-text="item.fileFormat ? item.fileFormat : '-'"
                  style="width: 6%"
                ></td>
                <td
                  v-text="item.fileSize && item.fileSize != '0.0B' && item.fileSize != '0B'?item.fileSize:'-'"
                  style="width: 6%"
                ></td>
                <td style="width:10%;position: relative;">
                <template v-if="item.hash.length>20">
                  <el-tooltip class="item" effect="dark" :content="item.hash" >
                    <span class="text_hidden" style="width:112px;">{{ item.hash }}</span>
                  </el-tooltip>
                  <span class="copy_icon" :data-clipboard-text="item.hash" title="点击复制" @click="EvidenceCopyFn(index,'.copy_icon','.copy_icon_msg3','copy_icon_msg_none3','copy_icon_msg_block3')"></span>
                  <span class="copy_icon_msg3 copy_icon_msg_none3" >复制成功</span>
                </template>
                <span v-else>{{ item.hash }}</span>
              </td>
                <!-- <td v-text="item.hash" style="width: 10%"></td> -->
                <td v-text="item.evidenceStartTime" style="width: 10%">
                </td>
                <td class="remark" v-text="item.signTime" style="width: 10%">
                </td>
                <td class="data-actions">
                  
                  <span
                    class="icon-box icon-common-eye-disabled"
                    v-if="(item.expirationTime<curTime && $route.query.partnerId == 21)"
                    title="查看证书"
                    :style="{ left: '40%' }"
                  ></span>
                  <span
                    class="icon-box icon-common-eye"
                    title="查看证书"
                    v-else
                    @click="showCer(index, 2,3)"
                    :style="{ left: '40%' }"
                  ></span>
                </td>
            </tr>
          </tbody>
        </table>
        <div class="noDataBox" v-if="noDataEvidence">
          <img src="../../assets/images/common/nodata.png" />
          <p>&nbsp;&nbsp;&nbsp;&nbsp;您目前还没有数据...</p>
        </div>
        <paging :pageInfo="pageInfoEvidence" :isAsync="isAsync"></paging>
      </div>
    </div>
  </div>
</template>

<script>
import paging from "@/components/common/Paging.vue";
import detailTitleCon from "./detailTitleCon";
import constData from "../../lib/const";
//复制插件
import Clipboard from 'clipboard'; 
export default {
  data() {
    return {
      list: [],
      queryUrlParams: {},
      isEvidenceList: true,
      gobacklist: false,
      current: 0,
      extractInfo: {},
      extractList: {},
      isMark: true,
      pageInfoEvidence: {},
      isAsync: true,
      noDataEvidence: false,
      downloadUrl: "",
      downloadList: [],
      currentTable: "",
      pageInfo: {
        pageNumber: 1,
        pageSize: 10,
        totalPage: 3,
        totalRow: 30,
      },
      certificateType: {
        rights: [20001, 20002],
        evidenceTaken: [30001, 30002, 30003, 30004],
        liveRecord: [50001, 50002, 50003, 50004, 50005],
      },
      isShouldAdd: true,
      deletedPack: null,
      itemParas: [
        { name: "证据名称", width: "21.5%" },
        { name: "网页标题", width: "11%" },
        { name: "证据类别", width: "10.9%" },
        { name: "证据来源", width: "7.9%" },
        { name: "保全时间", width: "13%" },
        { name: "文件大小", width: "6%" },
        { name: "文件格式", width: "7.9%" },
        { name: "备注", width: "10.9%" },
        { name: "操作", width: "15%" },
      ],
      evidenceSave: {
          name: "evidenceSave",
          contentStatus: false,
          itemParas: [
            { name: "存证编号", width: "12%" },
            { name: "存证名称", width: "11%" },
            { name: "存证主体", width: "10%" },
            { name: "数据类型", width: "6%" },
            { name: "数据格式", width: "6%" },
            { name: "数据大小", width: "6%" },
            { name: "HASH值", width: "10%" },
            { name: "创建时间", width: "10%" },
            { name: "存证时间", width: "10%" },
            { name: "操作", width: "6%" },
          ],
        },
        evidenceSaveList:[],
        //存证续费过期时间，当前时间
        curTime:new Date().getTime()
    };
  },

  components: {
    paging,
    detailTitleCon,
  },
  methods: {
    //查看证书
    // goCertificate(item) {
    //   this.$router.push({
    //     path: "/cn/extractionDetail/certificate",
    //     query: { id: item.id, type: item.type, uid: item.uid },
    //   });
    // },
    goList() {
      if (this.$route.query.partnerId) {
        this.$router.push({ path: "list", query: { ...this.$route.query } });
      } else {
        let querys = JSON.parse(window.sessionStorage.getItem("evdenceQuery"));
        this.$router.push({ path: "list", query: { ...querys } });
      }
    },
    //获取存证证据详情列表
    getEvidenceSave() {
      this.$ajax
        .get("/webapi/extractEvidence/extractPreservationList", {
          params: {
            uid: this.extractInfo.userId || this.$route.query.uid,
            type:this.$route.query.types,
            taskId: this.$route.query.taskId,
            partnerId:this.$route.query.partnerId,
            extractingCode:this.$route.query.extractingCode,
            pageNumber: this.pageInfoEvidence.pageNumber,
            pageSize: this.pageInfoEvidence.pageSize,
          },
        })
        .then((res) => {
          let pageInfo = {};
          pageInfo.pageNumber = res.data.extraData.pageNumber;
          pageInfo.totalPage = res.data.extraData.totalPage;
          pageInfo.pageSize = res.data.extraData.pageSize;
          pageInfo.totalRow = res.data.extraData.totalRow;
          this.pageInfoEvidence = pageInfo;
          if (typeof res.data.extraData.list == "undefined") {
            this.evidenceSaveList = [];
          } else {
            res.data.extraData.list.forEach((value, index) => {
              value.isCheck = false;
              value.isJudicial = false;
              value.evidenceStartTime = this.$moment(
                value.evidenceStartTime
              ).format("YYYY-MM-DD HH:mm:ss");
              value.signTime = this.$moment(
                value.signTime
              ).format("YYYY-MM-DD HH:mm:ss");
              switch (value.dataType) {
                case 1:
                  value.typeName = "文件存证";
                  break;
                case 2:
                  value.typeName = "文本存证";
                  break;
                case 3:
                  value.typeName = "Hash存证";
                  break;
                case 4:
                  value.typeName = "交易凭证存证";
                  break;
                case 7:
                  value.typeName = "事务存证";
                  break;
              }
            });
            this.evidenceSaveList = res.data.extraData.list;
            if (this.evidenceSaveList.length == 0) {
              this.noDataEvidence = true;
            } else {
              this.noDataEvidence = false;
            }
            this.$store.commit("showLoading", false);
          }
        });
    },
    //获取提取列表
    dataRequst() {
      this.$store.commit("showLoading", true);
      this.noDataEvidence = false;
      if (this.$route.query.partnerId) {
        // console.log("Dsadasd",this.$router.history.current.path)
        this.queryUrlParams = this.$route.query;
      } else {
        this.queryUrlParams = JSON.parse(
          window.sessionStorage.getItem("evdenceQuery")
        );
      }
      // console.log( this.queryUrlParams,"qingqiu")
      window.sessionStorage.setItem(
        "evdenceQuery",
        JSON.stringify(this.queryUrlParams)
      );
      let pageNo = this.queryUrlParams.pageNumber
        ? this.queryUrlParams.pageNumber
        : 1;
      let pageSize = this.queryUrlParams.pageSize
        ? this.queryUrlParams.pageSize
        : 10;
      this.$ajax
        .get("/webapi/extractEvidence/extractList", {
          params: {
            extractingCode: this.queryUrlParams.extractingCode,
            pageNo,
            pageSize,
            pid: this.queryUrlParams.pid,
            partnerId: this.queryUrlParams.partnerId,
            type: this.queryUrlParams.type,
          },
        })
        .then((response) => {
          this.$store.commit("showLoading", false);
          // console.log(response,"提取列表")
          if (response.data.code == 200) {
            if (response.data.extraData.extractInfo) {
              // 提取信息
              this.extractInfo = response.data.extraData.extractInfo;
              this.extractInfo.createTimeFomate = this.$moment(
                this.extractInfo.create_time
              ).format("YYYY-MM-DD HH:mm:ss");
              window.sessionStorage.setItem(
                "extractInfo",
                JSON.stringify(this.extractInfo)
              );
            }
            // 页码信息
            let pageInfo = {};
            pageInfo.pageNumber = response.data.extraData.page.pageNumber;
            pageInfo.pageSize = response.data.extraData.page.pageSize;
            pageInfo.totalPage = response.data.extraData.page.totalPage;
            pageInfo.totalRow = response.data.extraData.page.totalRow;
            this.pageInfoEvidence = pageInfo;

            // 有数据or没有数据处理
            let resArr = response.data.extraData.page.list;
            if (resArr.length == 0) {
              this.noDataEvidence = true;
            }
            for (let i in resArr) {
              if (resArr[i].status == 1) {
                resArr[i].statusName = "确权";
              } else if (resArr[i].status == 2) {
                if (resArr[i].temp1 == 1) {
                  resArr[i].statusName = "确权";
                } else {
                  resArr[i].statusName = "取证";
                }
              } else if (resArr[i].status == 3) {
                resArr[i].statusName = "其他";
              } else if (resArr[i].status == 4) {
                resArr[i].statusName = "现场";
              }
              //证据类别
              if (resArr[i].productCode == "20001") {
                if (resArr[i].status == 1) {
                  switch (resArr[i].fileType) {
                    case 1:
                      resArr[i].productCodeName = "文本确权";
                      break;
                    case 2:
                      resArr[i].productCodeName = "图片确权";
                      break;
                    case 3:
                      resArr[i].productCodeName = "音频确权";
                      break;
                    case 4:
                      resArr[i].productCodeName = "视频确权";
                      break;
                    case 6:
                      resArr[i].productCodeName = "手机阵列";
                      break;
                    case 5:
                      resArr[i].productCodeName = "脱敏确权";
                      break;
                  }
                }
              } else if (resArr[i].status == 6 || resArr[i].status == 7) {
                resArr[i].statusName = "区块链存证";
                //存证
                switch (resArr[i].productCode) {
                  case "10001":
                    resArr[i].productCodeName = "文件存证";
                    break;
                  case "10002":
                    resArr[i].productCodeName = "文本存证";
                    break;
                  case "10003":
                    resArr[i].productCodeName = "Hash存证";
                    break;
                  case "10004":
                    resArr[i].productCodeName = "交易凭证存证";
                    break;
                  case "10005":
                    resArr[i].productCodeName = "事务存证";
                    break;
                }
              } else {
                resArr[i].productCodeName =
                  constData.GlobalConst.PRODUCT_CODE.expenseType[
                    Number(resArr[i].productCode)
                  ];
              }
              // 时间格式化
              resArr[i].createTimeFomate = this.$moment(
                resArr[i].createTime
              ).format("YYYY-MM-DD HH:mm:ss");
              resArr[i].finishTimeFomate = this.$moment(
                resArr[i].finishTime
              ).format("YYYY-MM-DD HH:mm:ss");
            }
            this.extractList = resArr;
          } else if (response.data.code == 500) {
            this.noDataEvidence = true;
            this.$store.dispatch("showMsgModal", {
              autoClose: true,
              info: response.data.message,
            });
          } else {
            this.noDataEvidence = true;
            this.$router.push("/");
          }
        });
    },
    showCer(index, types,flag,isChild) {
      if (types == 2) {
        //存证查看证书
        if(flag ==3){
          let item= this.evidenceSaveList[index]
          let type=item.type == 5?7:6;
          //存证查看证据
          this.$router.push({
            path: "certificate",
            query: {
              certificateNumber: this.evidenceSaveList[index].certificateNumber,
              id: item.id,
              type: 8,
              downType: 7,
              dataSources:this.extractInfo.dataSources,
              businessCode:item.fileType == 1 || item.fileType == 2 || item.fileType == 3|| item.fileType == 4?'':'wl',//文件存证有预览证据 wl-预览只有证书
              uid: this.$route.query.uid,
              taskId:item.temp3,
              isChild:1,
              partnerId: this.$route.query.partnerId,
              // md5sign: this.$md5(type + "truthso123" + item.id)
            }
          });
        }else{
          let item= this.extractList[index]
          let type=item.status == 7?7:6;
          //存证一级查看证据
            this.$router.push({
              path: "certificate",
              query: {
                certificateNumber: this.extractList[index].certificateNumber,
                id: item.temp3,
                type: type,
                downType: type,
                isChild,
                dataSources:this.extractInfo.dataSources,
                businessCode:item.fileType == 1 || item.fileType == 2 || item.fileType == 3|| item.fileType == 4?'':'wl',//文件存证有预览证据 wl-预览只有证书
                uid: this.extractInfo.userId,
                taskId:item.temp3,
                partnerId: this.$route.query.partnerId,
                // md5sign: this.$md5(type + "truthso123" + item.temp3)
              }
            });
        }
        // this.$router.push({
        //   path: "certificate",
        //   query: {
        //     id: this.evidenceSaveList[index].temp3,
        //     type: 5,
        //     types:this.evidenceSaveList[index].fileType,
        //     uid: this.extractInfo.userId,
        //     md5sign: this.$md5(
        //       5 + "truthso123" + this.evidenceSaveList[index].taskId
        //     ),
        //   },
        // });
      }else{
        // console.log( this.extractList[index].productCode);
        let type = 0,
          productCode = this.extractList[index].productCode;
        if (this.certificateType.rights.indexOf(parseInt(productCode)) !== -1) {
          if (productCode == 20002) {
            type = 2;
          } else {
            type = 1;
          }
        } else if (
          this.certificateType.evidenceTaken.indexOf(parseInt(productCode)) !== -1
        ) {
          type = 2;
        } else if (
          this.certificateType.liveRecord.indexOf(parseInt(productCode)) !== -1
        ) {
          type = 3;
        }
        let ph = "cn";
        if (this.$route.path.includes("cn")) {
          ph = "cn";
        } else {
          ph = "en";
        }
        // console.log(this.extractInfo.userId)
        this.$router.push({
          path: "certificate",
          query: {
            certificateNumber: this.extractList[index].certificateNumber,
            uid: this.extractList[index].userId,
            currentType: 2,
            ListIndex: 3,
            type: type,
            partnerId: this.queryUrlParams.partnerId,
          },
        });
      }
    },
    // getDetail (index) {
    //   this.gobacklist = true
    //   let path = this.$router.history.current.path;
    //   this.$router.push({path, query:{...this.queryUrlParams,	pid:this.extractList[index].id}	})
    // },
    //证据详情
    getDetail(index, type) {
      if (type == 2) {
        //存证证据详情
        this.gobacklist = true;
        let path = this.$router.history.current.path;
        this.$router.push({
          path,
          query: this.$getRouterQuery(this.queryUrlParams, {
            pid:'',
            status: 7,
            dataSources: this.extractInfo.dataSources,
            uid: this.extractInfo.userId,
            types:
              this.extractList[index].status == 7
                ? 5
                : this.extractList[index].fileType,
            taskId: this.extractList[index].temp3,
          }),
        });
      } else {
        this.gobacklist = true;
        let path = this.$router.history.current.path;
        this.$router.push({
          path,
          query: this.$getRouterQuery(this.queryUrlParams, {
            pid: this.extractList[index].id,
          }),
        });
      }
    },
    //复制id
    EvidenceCopyFn(ind,name,copyName,noneName,blockName) {
      var clipboard = new Clipboard(name);
      clipboard.on("success", e => {
      $(copyName).eq(ind).removeClass(noneName).addClass(blockName);
      setTimeout(() => {
        $(copyName).eq(ind).removeClass(blockName).addClass(noneName);
      }, 1000);
       // 释放内存
        clipboard.destroy();
      });
    },
  },
  mounted() {
    if (this.$route.query.status == 7 && this.$route.query.taskId) {
      //存证二级证据列表
      this.gobacklist = true;
      this.getEvidenceSave();
    } else {
      //一级列表
      this.dataRequst();
    }
    if(sessionStorage.getItem("extractInfo")){
      this.extractInfo=JSON.parse(sessionStorage.getItem("extractInfo"));
    }
  },
  watch: {
    $route() {
      let pos = this.$router.history.current.query.pos;
      if (pos == "download") {
        // 下载列表
        this.dowloadListRequest();
      } else {
        if (this.$route.query.status == 7 && this.$route.query.taskId) {
          //存证二级证据列表
          this.gobacklist = true;
          this.getEvidenceSave();
        } else {
          //一级列表
          this.dataRequst();
        }
      }
    },
  },
};
</script>

<style scope lang="scss">
@import "../../assets/common/icon.css";
.list {
  margin-top: 10px;
  padding: 20px;
  box-shadow: 0px 5px 10px 0px rgba(177, 177, 178, 0.58);
  border-radius: 4px;

  background-color: #fff;
  &-title {
    padding-left: 10px;
    border-left: 3px solid #366efc;
    font-size: 16px;
    font-weight: bold;
    color: #323232;
    .active {
      color: #366efc;
    }
  }
  table.table tr td {
    border-top: 1px solid #d2d2d2;
    border-left: 1px solid #d2d2d2;
  }
  .table {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
  }
  .table tr td {
    color: #888888;
    font-size: 14px;
    vertical-align: middle;
  }
  .table > tr:hover,
  .table thead > tr:hover,
  .table tbody > tr:hover {
    background-color: #f1f1f1 !important;
  }

  .table > thead {
    background-color: rgb(210, 210, 210);
  }
  .table > thead td {
    color: #595959;
  }
  .table thead tr {
    height: 38px;
    line-height: 38px;
  }
  .table tbody tr {
    height: 32px;
    line-height: 32px;
  }
  .table tbody tr td {
    font-size: 12px;
    color: #787878;
    line-height: 13px;
    padding: 7px;
  }
  .icon-box {
    display: inline-block;
    width: 18px;
    height: 18px;
    background-size: cover;
  }
  .list-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 22px;
    button {
      width: 100px;
      background: #366efc;
      color: #fff;
      border: 0;
      float: right;
      height: 30px;
      a {
        color: #fff;
      }
    }
    button:hover {
      background: #1f5af0;
    }
  }
  .noDataBox {
    width: 100%;
    text-align: center;
    min-height: 239px;
    border-bottom: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-top: -32px;
    padding-top: 52px;
  }
  .page-box {
    margin-top: 12px;
  }
}
/* // 字段复制功能样式 */
.text_hidden{
  padding-left: 3px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  float: left;
}
.copy_icon{
  width: 14px;
  height: 14px;
  display: inline-block;
  background: url('../../assets/images/common/copy-no.png') no-repeat;
  background-size: 100%;
  cursor: pointer;
  float: right;
  margin-right: 3px;
  position: absolute;
  right: 3px;
}
.copy_icon:hover{
  background: url('../../assets/images/common/copy-hor.png') no-repeat;
}
.copy_icon_msg1,.copy_icon_msg2,.copy_icon_msg3,.copy_icon_msg4{
  width: 60px;
  height:20px;
  background: #fff;
  text-align: center;
  line-height: 20px;
  color:#4F4F4F;
  font-size: 12px;
  border-radius: 2px;
  position: absolute;
  right: -55px;
  border:1px solid #DDDDDD;
  z-index: 9;
  top: 5px;
  box-shadow: 2px 1px 4px #B3B3B3;
}
.copy_icon_msg_none1,.copy_icon_msg_none2,.copy_icon_msg_none3,.copy_icon_msg_none4{
  display: none;
}
.copy_icon_msg_block1,.copy_icon_msg_block2,.copy_icon_msg_block3,.copy_icon_msg_block4{
  display: block;
}
</style>